<template>
  <el-row class="nodata">
    <el-col :span="24" class="d-flex align-center justify-content-center flex-column align-items-center mt-2 ">
      <lottie-player
        autoplay
        loop
        mode="normal"
        :src="'/static/lottie/' + source + '.json'"
        style="max-width: 220px;
        max-height: 220px;
        witdh: 100%;
        height: 100%;"
      >
      </lottie-player>

      <h3>{{ title }}</h3>
      <!-- <span>{{ showLoading }}</span> -->
      <p v-if="showLoading !== false || (showLoading === undefined && !!loading)">
        {{ $t("buttonGeneral.loading") }}
      </p>
      <p v-else>
        <template v-if="title == $t('participantManagament.attendeeList.participant.search.searchRegister')">
          {{ $t("participantManagament.attendeeList.participant.search.noFound") }}
        </template>
        <template v-else>
          <!-- {{ $t("buttonGeneral.notPublished") }} -->
          {{ $t("generic.nothingFound") }}
        </template>
      </p>
      <el-button-group v-if="showLoading === false || (showLoading === undefined && !!loading)" style="margin-top: 20px;">
        <el-button v-if="buttonAdd" @click="$emit('btnAdd')" type="primary" round size="mini" icon="fas fa-plus"> {{ $t("buttonGeneral.add") }} </el-button>
        <el-button v-if="buttonRefresh" @click="$emit('btnRefresh')" type="primary" round size="mini" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'"> {{ $t("buttonGeneral.refresh") }} </el-button>
      </el-button-group>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: ["source", "title", "buttonAdd", "buttonRefresh", "loading"],
  data() {
    return {
      showLoading: null,
    }
  },
  created() {
    setTimeout(() => {
      this.showLoading = this.loading
    }, 500);
  },
  watch: {
    loading: function(newVal) {
      setTimeout(() => {
        this.showLoading = newVal
      }, 500);
    }
  }
};
</script>

<style lang="less">
.nodata {
  h3 {
    font-size: 20px;
    color: #292f3b !important;
    font-weight: bold;
    margin: 0;
  }
  p {
    font-size: 14px;
    margin: 5px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HolaconLottieNoData.vue